import { render } from "./TabProduct.vue?vue&type=template&id=0b4a96a9"
import script from "./TabProduct.vue?vue&type=script&lang=js"
export * from "./TabProduct.vue?vue&type=script&lang=js"

import "./TabProduct.vue?vue&type=style&index=0&id=0b4a96a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__